import { render, staticRenderFns } from "./PriceAdjustDialog.vue?vue&type=template&id=4cdd5935"
import script from "./PriceAdjustDialog.vue?vue&type=script&lang=js"
export * from "./PriceAdjustDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceAdjustDialog.vue?vue&type=style&index=0&id=4cdd5935&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdd5935')) {
      api.createRecord('4cdd5935', component.options)
    } else {
      api.reload('4cdd5935', component.options)
    }
    module.hot.accept("./PriceAdjustDialog.vue?vue&type=template&id=4cdd5935", function () {
      api.rerender('4cdd5935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/samSrot/components/PriceAdjustDialog.vue"
export default component.exports